import LogoShort from '../../assets/icons/logo.svg?react';
import styled from 'styled-components';

const StyledLink = styled.a`
  display: inline-flex;
  text-decoration: none;
  height: 2.25rem;
  justify-content: center;
  align-items: center;
`;

export function LogoShortLink() {
  return (
    <StyledLink href="https://www.withtandem.com">
      <LogoShort title="tandem" />
    </StyledLink>
  );
}
